export function isHCP() {
  let windowLoc = window.location.href
  if (windowLoc.includes("/hcp")) {
    return true
  } else {
    return false
  }
}
